import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT, SUPPORT_EMAIL } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-night" data-id="element-98" data-mp="9ttjgiucqd2c">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-99" data-mp="9wfrskp2gwlm">
        <Reveal className="mx-auto flex max-w-3xl flex-col items-center gap-2 rounded-2xl border-2 border-volt bg-carbon p-4 text-center sm:p-6" data-id="element-100" data-mp="eu8u32n916gm">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-volt" data-id="element-101" data-mp="nu49xkrr1pmz">
            <ShieldCheckIcon size={26} className="text-carbon" data-id="element-102" data-mp="nrrnaub1qr3l" />
          </span>
          <h2 id="garantia" className="font-display text-lg uppercase leading-tight text-volt sm:text-2xl" data-id="element-103" data-mp="smxgme6s381p">
            🛡️ Garantía de Devolución de 30 Días
          </h2>
          <p className="font-display text-base uppercase text-white sm:text-xl" data-id="element-104" data-mp="12h787tnwc2bd">
            Tu compra está 100% protegida
          </p>
          <p className="text-[0.82rem] leading-snug text-steel sm:text-sm" data-id="element-105" data-mp="25sgjlix1kg2z">
            Tendrás 30 días para explorar {PRODUCT} y revisar sus seis tomos,
            ejercicios y bonos. Si consideras que el sistema no es adecuado para
            ti, puedes escribirnos dentro del período establecido para solicitar
            un reembolso de acuerdo con los términos de devolución.
          </p>
          <p className="text-[0.78rem] font-semibold text-white sm:text-sm" data-id="element-106" data-mp="2oiy5b3jgibeu">
            Soporte:{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-volt underline underline-offset-2" data-id="element-107" data-mp="2jj20x36ukhyr">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </Reveal>
      </div>
    </section>;
}